import React from 'react';
import PropTypes from 'prop-types';
import css from '@emotion/css';
import Dropdown from '../Dropdown';

import IconPng from '../IconPng';
import { flagsPaths, upperTwoToName, upperThreeToTwo } from '../../../constants/countries';

const { Option } = Dropdown;

class CountriesDropdown extends React.Component {
  render() {
    let countryNameDisplay = name => name;
    let countrySearchFilterValue = name => name;
    switch (this.props.countryFormat) {
      case 'upperTwo': {
        countryNameDisplay = name => `(${upperThreeToTwo[name]})`;
        countrySearchFilterValue = name => upperThreeToTwo[name];
        break;
      }
      case 'full': {
        countryNameDisplay = name => ` ${upperTwoToName[upperThreeToTwo[name]]}`;
        countrySearchFilterValue = name => upperTwoToName[upperThreeToTwo[name]];
        break;
      }
      case 'upperThree':
      default: {
        countryNameDisplay = name => `(${name})`;
        break;
      }
    }
    return (
      <Dropdown
        showSearch
        onChange={this.props.onChange}
        defaultValue={this.props.defaultValue}
        value={this.props.value}
        width={this.props.width}
        fullWidth={this.props.fullWidth}
        borderColor={this.props.borderColor}
        borderColorHover={this.props.borderColorHover}
        css={css`
          margin-right: ${this.props.marginRight};
          & .ant-select-search__field__wrap > input {
            border-radius: 0;
          }
        `}
        optionFilterProp="title"
      >
        {flagsPaths.map(value => (
          <Option
            key={`${countryNameDisplay(value.name)}${value.path}`}
            value={value.name}
            title={countrySearchFilterValue(value.name)}
          >
            {!this.props.hideFlag && <IconPng size={18} type={value.path} css={css``} />}
            {countryNameDisplay(value.name)}
          </Option>
        ))}
      </Dropdown>
    );
  }
}

CountriesDropdown.propTypes = {
  width: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  marginRight: PropTypes.string,
  borderColor: PropTypes.string,
  borderColorHover: PropTypes.string,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
};
export default CountriesDropdown;
